import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { RequestHistory, RequestFile, RequestBuildingUnitView, RequestCharge, RequestFeedback, PagedResult, PaginationModel} from '../models';

@Injectable()
export class RequestService extends BaseHttpService<any> {

  constructor(public httpClient: HttpClient) {
    super('request');
  }


  getRequestLocation(id: number): Observable<RequestBuildingUnitView[]> {
    return this.httpClient
      .get(this.uri + `${id}/locations`)
      .catch(this.handleError);
  }

  getRequestHistory(id: number): Observable<RequestHistory[]> {
    return this.httpClient
      .get(this.uri  + `${id}/history`)
      .catch(this.handleError);
  }
  getRequestCharge(id: number): Observable<RequestCharge[]> {
    return this.httpClient
      .get(this.uri + `${id}/charge`)
      .catch(this.handleError);
  }
  getRequestFiles(id: number): Observable<RequestFile[]> {
    return this.httpClient
      .get(this.uri + `${id}/files`)
      .catch(this.handleError);
  }

  getEventRequestFiles(id: number): Observable<RequestFile[]> {
    return this.httpClient
      .get(this.uri + `${id}/eventFiles`)
      .catch(this.handleError);
  }

  addFeedback(model: RequestFeedback): Observable<string> {

    return this.httpClient
      .put(this.uri + `${model.requestId}/add-feedback`, JSON.stringify(model))
      .catch(this.handleError)

  }
  getRequestFeedbacks(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<RequestFeedback>> {
    return this.httpClient
      .get(this.uri + '/GetFeedbackList' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/request.service.ts